module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-bold-grey.a9106e05.svg";